import * as React from 'react';
import classNames from 'classnames';

export type ProgressBarProps = {
    context?: 'error' | 'success' | 'warning';
    // Number between 0 and 100 indicating how progressed the bar is
    progress: number;
    progressLabel?: string;
    striped?: boolean;
    active?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ active, context, progress, progressLabel, striped }) => {
    const classes = classNames(
        'progress-bar',
        { active, [`progress-bar-${context}`]: context, 'progress-bar-striped': striped },
    );
    const valueNow = Math.min(100, Math.max(0, progress));

    return (
        <div className="progress">
            <div
                aria-valuemax={100}
                aria-valuemin={0}
                aria-valuenow={valueNow}
                className={classes}
                role="progressbar"
                style={{ width: `${valueNow}%` }}
            >
                {progressLabel ?? ''}
            </div>
        </div>
    );
};

ProgressBar.displayName = 'displayName';
